import React from "react";
import DashboardHeader from "./DashboardHeader";

const Dashboard = props => {
  return (
    <div>
      <DashboardHeader />
    </div>
  );
};

export default Dashboard;
